import { Outlet } from "react-router-dom";

const BanglaDesh = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default BanglaDesh;
